import {
  EventSearchIndexQuerySchema,
  SearchSearchQuerySchema
} from '~/services/api/generated/zod.gen'

const maxLengthOf = (schema: { maxLength: number | null }): number =>
  schema.maxLength ?? Number.MAX_SAFE_INTEGER

/** Longest address text both the events and store search `q` parameters accept, from the generated contract. */
export const ADDRESS_TEXT_MAX_LENGTH: number = Math.min(
  maxLengthOf(EventSearchIndexQuerySchema.shape.q.unwrap().unwrap()),
  maxLengthOf(SearchSearchQuerySchema.shape.q.unwrap().unwrap())
)
